import React, { Component } from 'react';
import Star from 'react-icons/lib/md/star';
import StarBorder from 'react-icons/lib/md/star-border';
import StarHalf from 'react-icons/lib/md/star-half';

class StarRating extends Component {

    render() {
        let rating = parseFloat(this.props.averageRating);        
        let size = Math.max(0, (Math.min(5, Math.round(rating * 2) / 2))) - 1; //subtract one for zero index array       
        let stars = []; 
        const starSize = 32;

        for(let i=0; i <= size; i++) {
            stars[i] = <Star key={i} size={starSize}/>            
        }
        let counter = Math.floor(size)+1;
        if(size % 1 > 0) {            
            stars[counter] = <StarHalf key={counter} size={starSize}/>            
            counter++;
        }
        for(let n=counter; n < 5; n++) {
            stars[n] = <StarBorder key={n} size={starSize}/>            
        }

       return (<div>{stars}</div>);
    }

}

export default StarRating;


// WEBPACK FOOTER //
// ./src/react/views/readerReviews/StarRating.jsx